import { Tooltip } from '@mantine/core';

import { IndicatorStatus } from '@/models/IndicatorStatus.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    status: IndicatorStatus;
    text: string;
    classNames?: {
        text?: string;
    };
    tooltip?: boolean;
    tooltipLabel?: string;
}

const StatusLamp = ({ status, text, classNames, tooltip, tooltipLabel }: Props) => {
    const status_color = {
        [IndicatorStatus.ACTIVE]: 'bg-green-500',
        [IndicatorStatus.DEGRADED]: 'bg-amber-400',
        [IndicatorStatus.INACTIVE]: 'bg-red-500',
        [IndicatorStatus.UNKNOWN]: 'bg-slate-300',
    };

    const text_element = <p className={classNames?.text}>{text}</p>;

    return (
        <div className="flex items-center gap-3">
            <div className={cn('size-3 min-w-3 rounded-full', status_color[status])} />
            {tooltip ? <Tooltip label={tooltipLabel ?? text}>{text_element}</Tooltip> : text_element}
        </div>
    );
};

export default StatusLamp;
